/**
 * Splash — logo while bootstrap runs (min 1.5s handled by App).
 */

import Logo from '../components/Logo'

export default function SplashScreen() {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a0a0f] transition-opacity duration-500">
      <div className="text-center space-y-4">
        <div className="relative flex items-center justify-center">
          {/* Strong glow behind the user's logo */}
          <div 
            className="absolute rounded-3xl bg-brand/30 blur-3xl" 
            style={{ width: 140, height: 140 }}
          />
          <div
            className="absolute rounded-3xl bg-brand-light/20 blur-2xl"
            style={{ width: 110, height: 110 }}
          />
          <Logo size="xl" className="relative z-10" />
        </div>
        <h1 className="text-2xl font-bold text-white tracking-tight">ProperWallet</h1>
      </div>
    </div>
  )
}
